import { useState } from "react";
import { Airframe } from "../../../../types/airframe";


export function useAirframeForm() {
  const [formData, setFormData] = useState<Partial<Airframe>>({});
  const [selected, setSelected] = useState<Airframe | null>(null);
  const [isCreate, setIsCreate] = useState(false);
  const [open, setOpen] = useState(false);

  const startCreate = () => {
    setSelected(null);
    setFormData({ etopsCategory: '120' } as Partial<Airframe>);
    setIsCreate(true);
    setOpen(true);
  };

  const startEdit = (airframe: Airframe) => {
    setSelected(airframe);
    // Convert date strings to ISO format for display
    const convertedAirframe = {
      ...airframe,
      dateManufactured: airframe.dateManufactured 
        ? typeof airframe.dateManufactured === 'string'
          ? airframe.dateManufactured.split('T')[0] // Extract date part only
          : airframe.dateManufactured
        : undefined, // Use undefined to match Airframe type
      lastHMVDate: airframe.lastHMVDate
        ? typeof airframe.lastHMVDate === 'string'
          ? airframe.lastHMVDate.split('T')[0]
          : airframe.lastHMVDate
        : undefined, // Use undefined to match Airframe type
      slots: airframe.slots, // Explicitly preserve slots
    };
    setFormData(convertedAirframe);
    setIsCreate(false);
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
    // Don't clear formData here - let startCreate/startEdit set it fresh
  };

  const change = (field: keyof Airframe, value: any) =>
    setFormData((p) => ({
      ...p,
      [field]: value,
      ...(field === "operatorId" ? { operatorName: null } : {}),
    }));

  return {
    formData,
    selected,
    isCreate,
    open,
    startCreate,
    startEdit,
    close,
    change,
    setOpen,
  };
}
